import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const enUS = {
  // Keyed by the stable `error_code` the /ub/proxy routes send alongside their
  // English message (SHO-324); see serverErrorMessage().
  "serverErrors": {
    "invalid_otp": "Invalid OTP",
    "no_store_permission": "This user does not have permission to access this merchant store."
  },
  "types": {
    "ring": "Ring",
    "pendant": "Pendant",
    "bracelet": "Bracelet",
    "earring": "Earrings",
    "jewelry": "Jewelry"
  },
  "sourceTypes": {
    "mined": "Mined",
    "labGrown": "Lab Grown"
  },
  "common": {
    "confirm": "Confirm",
    "logout": "Logout",
    "memoMode": "Memo Mode",
    "emailGemstones": "Email Gemstones",
    "cancel": "Cancel",
    "ok": "Ok",
    "close": "Close",
    "back": "Back",
    "continue": "Continue",
    "submit": "Submit",
    "print": "Print",
    "email": "Email",
    "error": "Error",
    "memo": "Memo",
    "invoice": "Invoice"
  },
  "bespoke": {
    "onlyOneDiamond": "Only one diamond can be selected when adding to jewelry",
    "onlyOnePairOfDiamonds": "Only one pair of diamonds can be selected when adding to jewelry"
  },
  "journeyBar": {
    "designYour": "Design Your {{jType}}",
    "chooseDiamond": "Choose Diamond",
    "diamond": "Diamond",
    "view": "View",
    "change": "Change",
    "chooseSetting": "Choose Setting",
    "setting": "Setting",
    "reset": "Reset",
    "completeSetting": "Complete {{jType}}"
  },
  "certificateModal": {
    "title": "Certificate"
  },
  "loginModal": {
    "signInWithEmail": "Sign in with email",
    "confirmEmail": "Confirm email",
    "confirmCode": "Confirm code",
    "signIn": "Sign In",
    "emailAddress": "Email Address",
    "codeSentTo": "A 6-digit pass code was sent to:",
    "codeExpiresIn": "Code expires in",
    "resendCode": "Resend code",
    "codeSentSuccessfully": "Code sent successfully"
  },
  "bookmarksModal": {
    "title": "Email Diamonds",
    "link": "Link",
    "copied": "copied",
    "jewelryOptions": "Jewelry options",
    "jewelryOptionsHint": "Jewelry types your customer can add the {{stoneType}}s to",
    "jewelryOptionsHint_diamond": "Jewelry types your customer can add the diamonds to",
    "jewelryOptionsHint_gemstone": "Jewelry types your customer can add the gemstones to",
    "allJewelry": "All",
    "rings": "Rings",
    "pendants": "Pendants",
    "bracelets": "Bracelets",
    "linkPreview": "Link preview",
    "curatedIntroSuffix": "has hand-curated the following {{stoneType}}s for you. Please follow the link below to preview your {{stoneType}}s.",
    "curatedIntroSuffix_diamond": "has hand-curated the following diamonds for you. Please follow the link below to preview your diamonds.",
    "curatedIntroSuffix_gemstone": "has hand-curated the following gemstones for you. Please follow the link below to preview your gemstones.",
    "mailtoSubject": "Curated {{stoneType}}s",
    "mailtoSubject_diamond": "Curated diamonds",
    "mailtoSubject_gemstone": "Curated gemstones",
    "mailtoBody": "{{shopName}} has hand-curated a selection of {{stoneType}}s for you. \n\n Please follow the link below to preview your {{stoneType}}s.\n\n ",
    "mailtoBody_diamond": "{{shopName}} has hand-curated a selection of diamonds for you. \n\n Please follow the link below to preview your diamonds.\n\n ",
    "mailtoBody_gemstone": "{{shopName}} has hand-curated a selection of gemstones for you. \n\n Please follow the link below to preview your gemstones.\n\n ",
    "composeEmail": "Compose email",
    "linkCopiedAlready": "(link copied to clipboard already)",
    "noStarredDiamonds": "No starred diamonds found",
    "starOneDiamond": "Star at least one diamond to email",
    "noStarredGemstones": "No starred gemstones found",
    "starOneGemstone": "Star at least one gemstone to email"
  },
  "confirmationModal": {
    "confirmPromptPrefix": "Please confirm you would like to",
    "confirmPromptSuffix": "the following {{stoneType}}.",
    "confirmPromptSuffix_diamond": "the following diamond.",
    "confirmPromptSuffix_gemstone": "the following gemstone.",
    "confirmMemoBtn": "Confirm Memo",
    "invoiceBtn": "Invoice {{stoneType}}",
    "invoiceBtn_diamond": "Invoice diamond",
    "invoiceBtn_gemstone": "Invoice gemstone"
  },
  "dasOrderSuccessModal": {
    "header": "Your {{orderTypeName}} is Confirmed"
  },
  "diamondsTable": {
    "origin": "Origin",
    "carat": "Carat",
    "color": "Color",
    "clarity": "Clarity",
    "cut": "Cut",
    "price": "Price",
    "gradeIdeal": "Ideal",
    "gradeExcellent": "Excellent",
    "gradeVeryGood": "Very Good",
    "gradeGood": "Good",
    "gradeFair": "Fair"
  },
  "collection": {
    "pageHeading": "Diamond Collection Page",
    "fromPrice": "From {{price}}",
    "noProductsFound": "No products found",
    "cannotRetrieveProducts": "Sorry, cannot retrieve products.",
    "diamondNotAvailable": "Diamond is not available",
    "diamondOutOfStock": "Sorry, diamond is out of stock",
    "applicationError": "Application Error"
  },
  "errors": {
    "emailError": "Email error",
    "failedToSendEmail": "Failed to send email",
    "invalidOrderData": "Invalid order data",
    "invalidOrderDataBody": "One or more items could not be processed due to missing data",
    "anErrorOccurred": "An error occured",
    "orderProcessError": "Order process Error",
    "createProductsError": "Create products error",
    "unableToCreateProductsFor": "Unable to create products for {{skus}}",
    "invalidCartData": "Invalid cart data",
    "invalidCartDataBody": "One or more items could not be added due to missing data",
    "addToCartError": "Add to cart error",
    "unableToAddToCart": "Unable to add to cart",
    "appNotification": "App notification",
    "duplicateGem": "The diamond/gemstone is either already in the cart or a duplicate.",
    "diamondAlreadyInCart": "This diamond is already in your cart.",
    "cartUnavailable": "Cart unavailable",
    "cartUnavailableBody": "Unable to verify your cart. Please refresh the page and try again.",
    "htoKitActive": "Home Try-On Kit active",
    "htoKitActiveBody": "Your cart contains a Home Try-On Kit. Please complete or clear your Try-On order before adding other items.",
    "tryAgainInAMoment": "Please try again in a moment.",
    "diamondSold": "Diamond has been sold",
    "diamondsNotAvailable": "Diamonds with skus ({{skus}}) are not available",
    "applicationError": "Application error",
    "addToCartRequestError": "Error processing add to cart request"
  }
};

// en-GB differs from en-US only where the storefront already used British
// spellings; every other string is shared so both English locales stay identical.
export const enGB: typeof enUS = {
  ...enUS,
  "types": {
    ...enUS.types,
    "jewelry": "Jewellery"
  }
};

export const frCA: typeof enUS = {
  "serverErrors": {
    "invalid_otp": "Code invalide",
    "no_store_permission": "Cet utilisateur n'a pas l'autorisation d'accéder à cette boutique."
  },
  "types": {
    "ring": "Bague",
    "pendant": "Pendentif",
    "bracelet": "Bracelet",
    "earring": "Boucles d'oreilles",
    "jewelry": "Bijou"
  },
  "sourceTypes": {
    "mined": "Naturel",
    "labGrown": "Cultivé en laboratoire"
  },
  "common": {
    "confirm": "Confirmer",
    "logout": "Déconnexion",
    "memoMode": "Mode mémo",
    "emailGemstones": "Envoyer les pierres par courriel",
    "cancel": "Annuler",
    "ok": "Ok",
    "close": "Fermer",
    "back": "Retour",
    "continue": "Continuer",
    "submit": "Soumettre",
    "print": "Imprimer",
    "email": "Courriel",
    "error": "Erreur",
    "memo": "Mémo",
    "invoice": "Facture"
  },
  "bespoke": {
    "onlyOneDiamond": "Un seul diamant peut être sélectionné lors de l'ajout à un bijou",
    "onlyOnePairOfDiamonds": "Une seule paire de diamants peut être sélectionnée lors de l'ajout à un bijou"
  },
  "journeyBar": {
    "designYour": "Concevez votre {{jType}}",
    "chooseDiamond": "Choisir un diamant",
    "diamond": "Diamant",
    "view": "Voir",
    "change": "Changer",
    "chooseSetting": "Choisir une monture",
    "setting": "Monture",
    "reset": "Réinitialiser",
    "completeSetting": "Compléter {{jType}}"
  },
  "certificateModal": {
    "title": "Certificat"
  },
  "loginModal": {
    "signInWithEmail": "Se connecter par courriel",
    "confirmEmail": "Confirmer le courriel",
    "confirmCode": "Confirmer le code",
    "signIn": "Se connecter",
    "emailAddress": "Adresse courriel",
    "codeSentTo": "Un code d'accès à 6 chiffres a été envoyé à :",
    "codeExpiresIn": "Le code expire dans",
    "resendCode": "Renvoyer le code",
    "codeSentSuccessfully": "Code envoyé avec succès"
  },
  "bookmarksModal": {
    "title": "Envoyer les diamants par courriel",
    "link": "Lien",
    "copied": "copié",
    "jewelryOptions": "Options de bijoux",
    "jewelryOptionsHint": "Types de bijoux auxquels votre client peut ajouter les {{stoneType}}s",
    "jewelryOptionsHint_diamond": "Types de bijoux auxquels votre client peut ajouter les diamants",
    "jewelryOptionsHint_gemstone": "Types de bijoux auxquels votre client peut ajouter les pierres précieuses",
    "allJewelry": "Tous",
    "rings": "Bagues",
    "pendants": "Pendentifs",
    "bracelets": "Bracelets",
    "linkPreview": "Aperçu du lien",
    "curatedIntroSuffix": "a sélectionné avec soin les {{stoneType}}s suivants pour vous. Veuillez suivre le lien ci-dessous pour prévisualiser vos {{stoneType}}s.",
    "curatedIntroSuffix_diamond": "a sélectionné avec soin les diamants suivants pour vous. Veuillez suivre le lien ci-dessous pour prévisualiser vos diamants.",
    "curatedIntroSuffix_gemstone": "a sélectionné avec soin les pierres précieuses suivantes pour vous. Veuillez suivre le lien ci-dessous pour prévisualiser vos pierres précieuses.",
    "mailtoSubject": "Sélection de {{stoneType}}s",
    "mailtoSubject_diamond": "Sélection de diamants",
    "mailtoSubject_gemstone": "Sélection de pierres précieuses",
    "mailtoBody": "{{shopName}} a sélectionné avec soin un choix de {{stoneType}}s pour vous. \n\n Veuillez suivre le lien ci-dessous pour prévisualiser vos {{stoneType}}s.\n\n ",
    "mailtoBody_diamond": "{{shopName}} a sélectionné avec soin un choix de diamants pour vous. \n\n Veuillez suivre le lien ci-dessous pour prévisualiser vos diamants.\n\n ",
    "mailtoBody_gemstone": "{{shopName}} a sélectionné avec soin un choix de pierres précieuses pour vous. \n\n Veuillez suivre le lien ci-dessous pour prévisualiser vos pierres précieuses.\n\n ",
    "composeEmail": "Rédiger un courriel",
    "linkCopiedAlready": "(lien déjà copié dans le presse-papiers)",
    "noStarredDiamonds": "Aucun diamant favori trouvé",
    "starOneDiamond": "Ajoutez au moins un diamant à vos favoris pour l'envoyer par courriel",
    "noStarredGemstones": "Aucune pierre précieuse favorite trouvée",
    "starOneGemstone": "Ajoutez au moins une pierre précieuse à vos favoris pour l'envoyer par courriel"
  },
  "confirmationModal": {
    "confirmPromptPrefix": "Veuillez confirmer que vous souhaitez",
    "confirmPromptSuffix": "le {{stoneType}} suivant.",
    "confirmPromptSuffix_diamond": "le diamant suivant.",
    "confirmPromptSuffix_gemstone": "la pierre précieuse suivante.",
    "confirmMemoBtn": "Confirmer le mémo",
    "invoiceBtn": "Facturer {{stoneType}}",
    "invoiceBtn_diamond": "Facturer le diamant",
    "invoiceBtn_gemstone": "Facturer la pierre précieuse"
  },
  "dasOrderSuccessModal": {
    "header": "Votre {{orderTypeName}} est confirmé"
  },
  "diamondsTable": {
    "origin": "Origine",
    "carat": "Carat",
    "color": "Couleur",
    "clarity": "Clarté",
    "cut": "Taille",
    "price": "Prix",
    "gradeIdeal": "Idéale",
    "gradeExcellent": "Excellente",
    "gradeVeryGood": "Très bonne",
    "gradeGood": "Bonne",
    "gradeFair": "Passable"
  },
  "collection": {
    "pageHeading": "Page de la collection de diamants",
    "fromPrice": "À partir de {{price}}",
    "noProductsFound": "Aucun produit trouvé",
    "cannotRetrieveProducts": "Désolé, impossible de récupérer les produits.",
    "diamondNotAvailable": "Diamant non disponible",
    "diamondOutOfStock": "Désolé, ce diamant est en rupture de stock",
    "applicationError": "Erreur de l'application"
  },
  "errors": {
    "emailError": "Erreur de courriel",
    "failedToSendEmail": "Échec de l'envoi du courriel",
    "invalidOrderData": "Données de commande invalides",
    "invalidOrderDataBody": "Un ou plusieurs articles n'ont pu être traités en raison de données manquantes",
    "anErrorOccurred": "Une erreur est survenue",
    "orderProcessError": "Erreur de traitement de la commande",
    "createProductsError": "Erreur de création des produits",
    "unableToCreateProductsFor": "Impossible de créer les produits pour {{skus}}",
    "invalidCartData": "Données de panier invalides",
    "invalidCartDataBody": "Un ou plusieurs articles n'ont pu être ajoutés en raison de données manquantes",
    "addToCartError": "Erreur d'ajout au panier",
    "unableToAddToCart": "Impossible d'ajouter au panier",
    "appNotification": "Notification de l'application",
    "duplicateGem": "Ce diamant ou cette pierre précieuse est déjà dans le panier ou en double.",
    "diamondAlreadyInCart": "Ce diamant est déjà dans votre panier.",
    "cartUnavailable": "Panier indisponible",
    "cartUnavailableBody": "Impossible de vérifier votre panier. Veuillez actualiser la page et réessayer.",
    "htoKitActive": "Trousse d'essai à domicile active",
    "htoKitActiveBody": "Votre panier contient une trousse d'essai à domicile. Veuillez finaliser ou vider votre commande d'essai avant d'ajouter d'autres articles.",
    "tryAgainInAMoment": "Veuillez réessayer dans un instant.",
    "diamondSold": "Ce diamant a été vendu",
    "diamondsNotAvailable": "Les diamants portant les SKU ({{skus}}) ne sont pas disponibles",
    "applicationError": "Erreur de l'application",
    "addToCartRequestError": "Erreur lors du traitement de la demande d'ajout au panier"
  }
};

const country = (window as any).Shopify?.country || "US";
const locale = (window as any).Shopify?.locale || "en";

const shopifyLang = `${locale}-${country}`;

// window.ubDS.effectiveLocale is already gated by merchant opt-in (see theme extension),
// so only "fr-CA" from it should override the Shopify-derived language.
const ubDsEffectiveLocale = (window as any).ubDS?.effectiveLocale;
const initialLng = ubDsEffectiveLocale === "fr-CA" ? "fr-CA" : shopifyLang;

i18n
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: "en",
    debug: false,
    resources: {
      "en-US": { translation: enUS },
      "en-GB": { translation: enGB },
      "en": { translation: enUS },
      "fr-CA": { translation: frCA }
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

// ubDS.effectiveLocale can arrive after this module's own init (it's populated async
// from the theme extension's /app_version fetch), so the app root polls this once mounted.
export const applyUbDsLocale = (): void => {
  const effectiveLocale = (window as any).ubDS?.effectiveLocale;
  if (effectiveLocale === "fr-CA" && i18n.language !== "fr-CA") {
    i18n.changeLanguage("fr-CA");
  }
};

export const getEffectiveLocale = (): string => i18n.language || initialLng;

// @unbridaled/search-sdk >= 4.3.0 ships its own en-US/fr-CA dictionaries and
// only understands those two locales (anything else renders en-US). The host's
// en-GB spelling split doesn't apply to SDK text.
export type SearchSdkLocale = 'en-US' | 'fr-CA'

export const toSearchSdkLocale = (lang: string | undefined): SearchSdkLocale =>
  lang === 'fr-CA' ? 'fr-CA' : 'en-US'

export const getSearchSdkLocale = (): SearchSdkLocale => toSearchSdkLocale(getEffectiveLocale())

// Proxy routes return a stable error code next to their English message; show
// our translation for known codes and the server's own text otherwise (e.g.
// DAS messages, which carry no code).
export function serverErrorMessage(
  payload: { error_code?: string; error_message?: string } | null | undefined
): string | undefined {
  const key = payload?.error_code ? `serverErrors.${payload.error_code}` : undefined
  return key && i18n.exists(key) ? i18n.t(key) : payload?.error_message
}

export default i18n;
